import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./index.css";
import { CustomCursor } from "@/shared/components/effects/custom-cursor";
import { DesignSystemPage } from "@/pages/design/page";
import { HomePage } from "@/pages/home/page";
import { PrivacyPage } from "@/pages/public/privacy/page";

export function App() {
  return (
    <BrowserRouter>
      <CustomCursor />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/design" element={<DesignSystemPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
